import Vue from "vue";
import Modal from "../../vue/partials/Modal.vue";

function pharmacySearch() {
  let stateCheck = setInterval(() => { if (document. readyState === 'complete') {
    clearInterval(stateCheck);
  const search = document.getElementById('pharmacySearch'),
    list = document.querySelector('#data-search'),
    container = document.querySelector('.pharmacy-search'),
    suggestions = document.querySelector('.pharmacy-search__suggestions'),
    searchBtn = document.querySelector('.js-pharmacy-search-btn'),
    resetSearchBtn = document.querySelector('.pharmacy-search-reset'),
    pharmacyItems = document.querySelector('.pharmacy-list'),
    category = document.querySelector('.pharmacy-section__container'),
    categoryMobile = document.querySelector('.pharmacy-category-mobile'),
    resultsWrapper = document.querySelector('.pharmacy-search-results'),
    containerForm = container?.querySelector('.form-search'),
    blurClassname = 'backdrop-is-visible';

  const pharmacyArray = (list?.dataset.searchPharmacies ? JSON.parse(list.dataset.searchPharmacies) : []);

  function findMatch(word, pharmacyArray) {
    let result = [];
    word.replace(/,/ , ' ');
    const arrWord = word.split(" ", 3);
    arrWord.forEach((word) => {
      const a = pharmacyArray.filter(el => {
        const regex = new RegExp(word, 'gi');
        return el.city.match(regex);
      });
      const b = pharmacyArray.filter(el => {
        const regex = new RegExp(word, 'gi');
        return el.label.match(regex);
      });
      const c = pharmacyArray.filter(el => {
        const regex = new RegExp(word, 'gi');
        return el.street.match(regex);
      });
      let matched = (a.concat(b.filter((item) => a.indexOf(item) < 0)));
      matched = (matched.concat(c.filter((item) => matched.indexOf(item) < 0)));
      result = (result.concat(matched.filter((item) => result.indexOf(item) < 0)));

    });
    return result;
  }

  // Show search suggestions on suggestions list
  function showSuggestions() {
    if (this.value.length == 0) {
      return;
    }

    const suggestionsList = suggestions.querySelector('.pharmacy-search__list');
    const matchArray = findMatch(this.value, pharmacyArray);
    containerForm.classList.add(blurClassname);
    containerForm.classList.add('is-active');
    container.classList.add('is-active');
    const html = matchArray.map(el => {
      const regex = new RegExp(this.value, 'gi');
      const pharmacyName = el.label + ", " + capitalizeTitle(el.city) + ", " + capitalizeTitle(el.street);
      const pharmacyLink = el.url;
      return `
              <li>
                <a href="${pharmacyLink}">${pharmacyName}</a>
              </li>
            `;
    }).join('');

    resetSearchBtn.classList.remove('hidden');
    search.classList.add('is-active');
    searchBtn.classList.add('is-active');
    suggestions.classList.remove('hidden');


    if (html.length > 0) {
      suggestionsList.innerHTML = html;
      searchBtn.classList.remove('disabled');
      search.classList.add('is-active');
    } else {
      searchBtn.classList.add('disabled');
      suggestionsList.innerHTML = '<p>Brak wyników wyszukiwania. Wpisz inną frazę.</p>';
    }
  }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && resetSearchBtn.classList.contains('hidden') == false) {
        resetSearch();
      }
    });


  function hideSuggestions() {
    containerForm?.classList.remove(blurClassname);
    containerForm?.classList.remove('is-active');
    searchBtn?.classList.remove('is-active');
    searchBtn?.classList.add('disabled');
    search?.classList.remove('is-active');
    suggestions?.classList.add('hidden');
    resetSearchBtn?.classList.add('hidden');
  }

  // Show search results on pharmacy-list
  function showResults() {
    pharmacyItems.classList.add('show-results');
    container.classList.remove('is-active');
    category.classList.add('is-hidden');
    categoryMobile.classList.add('is-hidden');
    resultsWrapper.classList.add('is-visible');

    const pharmacyList = [...document.querySelectorAll('.pharmacy-list__item')];
    const searchResults = pharmacyList.filter(el => {
      const text = el.innerText;
      const regex = new RegExp(search.value, 'gi');
      return text.match(regex);
    });

    searchResults.forEach((result) => result.classList.add("search-visible"));
  }

  function resetSearch() {
    hideSuggestions();
    search.value = '';
  }

  resetSearchBtn?.addEventListener('click', resetSearch);

  search?.addEventListener('keyup', showSuggestions);

  document.addEventListener('click', function handleClickOutsideBox(event) {
    if (!search?.contains(event.target)) {
      hideSuggestions();
    }
  })

  function capitalizeTitle(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }

  const buttonClosest = document.querySelector('.js-findClosest');
  buttonClosest?.addEventListener("click", checkGeolocation);

  function checkGeolocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        getClosestPharmacy,
        cannotGetClosestPharmacy
      );
    }
  }

  const getClosestPharmacy = (position) => {
    let pharmacyNear = {};
    if (position.coords.latitude && position.coords.longitude) {
      let shortest = 500;
      pharmacyArray.forEach((pharmacy) => {
        //simplified distance calculation
        const distance = Math.abs(pharmacy.longitude - position.coords.longitude) + Math.abs(pharmacy.latitude - position.coords.latitude);
        if (shortest > distance) {
          shortest = distance;
          pharmacyNear = pharmacy;
        }
      });
      window.location.href = pharmacyNear.url;
    }
  }

  const cannotGetClosestPharmacy = (error) => {
    const modal = Vue.extend(Modal);
    window.$apteline.modal.OpenModal({
      title: '',
      content: '<p><strong>Nie udostępniono lokalizacji.</strong></p><p>Wejdź w ustawienia przeglądarki i zmień ustawienie udotępniania lokalizacji.</p>',
      buttons: []
    });
  }
  } }, 100);
}

export { pharmacySearch }



